// =====================================================================
// Login.jsx - pagina de login
// =====================================================================
// Faza 3.4b: REVERT L-047 workaround (window.location.href).
// Cu AuthContext din 3.4b, state-ul auth e SHARED -> dupa login,
// instanta useAuth din App.jsx vede user actualizat instant ->
// route guard accept -> navigate() SPA functioneaza nativ.
//
// Bonus: tranzitia e instant (zero page reload), feeling SPA pastrat.
// =====================================================================

import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';
import { retourDe } from '../lib/retourApresLogin.js';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  // 23-10-2026 : page demandée avant la connexion (ex. /accidents?scan=BS-01), posée par App.jsx.
  const retour = retourDe(location);
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const u = await login(username, password);
      // Day 9d: if must change password, force redirect to change-password page
      if (u?.mustChangePassword) {
        navigate('/change-password');
      } else {
        // Day 9: redirect via root which decides based on role (admin → /dashboard, else → /temps)
        // — sauf si une page précise était demandée (autocollant scanné avant la connexion).
        navigate(retour || '/');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Brain E-Log</h1>
        <p className="subtitle">Connexion à votre compte</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Identifiant</label>
            <input
              type="text"
              required
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          
          <div className="form-row">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <small style={{ display: 'block', marginTop: 4, color: '#6b7280', fontSize: 12 }}>
              Première connexion ? Laissez vide — vous choisirez votre mot de passe ensuite.
            </small>
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
        {/* 23-10-2026 — lien par e-mail (compte actif, sous contrat, avec une adresse) */}
        <div style={{ marginTop: 14, textAlign: 'center' }}>
          <Link to="/mot-de-passe-oublie" style={{ fontSize: 13, color: '#4f46e5' }}>Mot de passe oublié ?</Link>
        </div>
      </div>
    </div>
  );
}
